<template>
    <div class="card">
        <div class="card-header">{{ localizationStore.translate('send.an.invite') }}</div>
        <div class="card-body">
            <form >
                <div class="form-group">
                    <label for="email">Email</label>
                    <input type="text" class="form-control" name="email" id="email" v-model="email">
                </div>
                <button
                    type="button"
                    class="btn btn-primary"
                    v-if="teamStore.team.canAddTeamMember"
                    @click="addUser"
                >
                    {{ localizationStore.translate('send.invite') }}
                </button>
                <div class="item-options pro-plan" v-else>
                    <a
                        :href="getRoute('billing-plans')"
                        type="button"
                        class="btn btn-primary waves-effect waves-light btn-cart"
                    >
                        <span class="">{{ localizationStore.translate('max.limit') }}</span>
                    </a>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import { useTeamStore } from '../../../stores/TeamStore.js'
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { ref } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import axios from 'axios'
import { getRoute } from '../../../utilities/_helpers'

export default {
    data(){
        return{
            email : ''
        }
    },
    setup(){
        return{
            teamStore:useTeamStore(),
            localizationStore:useLocalizationStore(),
            vuelidate:useVuelidate(),
            getRoute: getRoute
        }
    },
    validations () {
        return {
            email : { required },
        }
    },
    methods:{
        addUser(){
            this.vuelidate.$validate();
            if(this.vuelidate.$error <= 0 ){
                const $this = this;
                const route = $this.$router.resolve(
                    {
                        name: 'teams-invite',
                        params: {
                            team: $this.teamStore.team.team.id,
                        }
                    }
                );
                axios.post(
                    route.href,
                    {
                        email: $this.email
                    }
                )
                .then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Team Invite');
                        return;
                    }
                    $this.email = "";
                    $this.teamStore.fetchTeam();
                    toastr.success(response.data.message, 'Team Invite');
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Invite Error');
                });
            }

        },
    }
}
</script>
